import { render, staticRenderFns } from "./border-refound-status.vue?vue&type=template&id=47f8cefb&scoped=true&"
import script from "./border-refound-status.vue?vue&type=script&lang=js&"
export * from "./border-refound-status.vue?vue&type=script&lang=js&"
import style0 from "./border-refound-status.vue?vue&type=style&index=0&id=47f8cefb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f8cefb",
  null
  
)

export default component.exports